__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "src-rx";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@iobroker/adapter-react-v5", "4.9.5", () => (Promise.all([__webpack_require__.e(8364), __webpack_require__.e(4632), __webpack_require__.e(5555), __webpack_require__.e(978), __webpack_require__.e(5912), __webpack_require__.e(2813), __webpack_require__.e(51), __webpack_require__.e(9562), __webpack_require__.e(8866), __webpack_require__.e(566), __webpack_require__.e(2920), __webpack_require__.e(3973), __webpack_require__.e(1670)]).then(() => (() => (__webpack_require__(67218))))));
			register("@mui/icons-material", "5.15.6", () => (Promise.all([__webpack_require__.e(4632), __webpack_require__.e(248), __webpack_require__.e(8866), __webpack_require__.e(566)]).then(() => (() => (__webpack_require__(50248))))));
			register("@mui/material", "5.14.14", () => (Promise.all([__webpack_require__.e(4632), __webpack_require__.e(978), __webpack_require__.e(5912), __webpack_require__.e(8449), __webpack_require__.e(9061), __webpack_require__.e(8866), __webpack_require__.e(566), __webpack_require__.e(2920)]).then(() => (() => (__webpack_require__(19061))))));
			register("@mui/styles", "5.14.14", () => (Promise.all([__webpack_require__.e(5555), __webpack_require__.e(8866), __webpack_require__.e(566), __webpack_require__.e(5273)]).then(() => (() => (__webpack_require__(46569))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(3090).then(() => (() => (__webpack_require__(63090))))));
			register("react-ace", "10.1.0", () => (Promise.all([__webpack_require__.e(4986), __webpack_require__.e(872), __webpack_require__.e(8866), __webpack_require__.e(566)]).then(() => (() => (__webpack_require__(20872))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(2882), __webpack_require__.e(8866)]).then(() => (() => (__webpack_require__(2882))))));
			register("react", "18.2.0", () => (__webpack_require__.e(3617).then(() => (() => (__webpack_require__(53617))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};